import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { UiContext } from 'uiContext';
import { WeatherType } from 'mobx/commonTypes';
import { getWeatherConditionLabel } from './helper';
import WeatherIconWrapper from './weatherIconWrapper';

export default function WeatherForecast({ weather }: { weather: WeatherType }) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  const { cond, temp } = weather;

  return (
    <Box
      sx={{
        display: 'grid',
        alignItems: 'center',
        gridTemplateColumns: 'auto 1fr',
        py: sp.s30,
        px: sp.s50,
        gap: sp.s30,
      }}
    >
      <WeatherIconWrapper condition={cond} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant="f14">{getWeatherConditionLabel(cond)}</Typography>
        <Typography variant="f14">{temp} &#8451;</Typography>
      </Box>
    </Box>
  );
}
